(() => {
  angular.module('app').component('corporateBenefitGroupsInpatientBenefitDetailBasicsComponent', {
    templateUrl: require('./basics.component.html'),
    controller: BasicsComponentController,
    controllerAs: 'vm',
    bindings: {
      basics: '<',
    },
  });

  BasicsComponentController.$inject = ['$uibModal', '$sce', 'Hms.BenefitGroups.DependentType'];

  function BasicsComponentController($modal, $sce, enumDependentType) {
    const vm = this;
    vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
    vm.loading = false;
    vm.hasHospitalizationWaitingPeriodEnhancement = abp.setting.getBoolean(
        'Hms.Feature.HospitalisationWaitingPeriodEnhancement'
    );

    vm.hasOptionalExclusions = true;
    vm.showViewExclusionProvisions = showViewExclusionProvisionsModal;

    vm.displaySafeHtml = displaySafeHtml;
    vm.$onInit = init;

    function init() {
      loadBasicsData();
      checkOptionalExclusions();
    }

    function loadBasicsData() {
      vm.loading = true;

      const relationshipMap = {};
      (enumDependentType.values ?? []).forEach(item => {
        relationshipMap[item.id] = item.name;
      });

      vm.dependentsCovered = (vm.basics.hospitalizationSetting.dependentsCovered ?? [])
        .map(num => relationshipMap[num] || `Unknown(${num})`)
        .join(', ');

      vm.loading = false;
    }

    function displaySafeHtml(html) {
      return $sce.trustAsHtml(html);
    }

    function checkOptionalExclusions() {
      if (vm.basics.serviceType === 7) {
        let j = 0;
        for (
          let i = 0;
          i < vm.basics.hospitalizationSetting.coveredOptionalExclusions.length;
          i += 1
        ) {
          if (!vm.basics.hospitalizationSetting.coveredOptionalExclusions[i].valid) {
            j += 1;
          }
        }
        if (j === vm.basics.hospitalizationSetting.coveredOptionalExclusions.length) {
          vm.hasOptionalExclusions = false;
        }
      }
    }

    function showViewExclusionProvisionsModal() {
      $modal.open({
        templateUrl: require('../viewExclusionProvisions/viewExclusionProvisions.modal.html'),
        controller:
          'corporate.views.benefitGroups.inpatient.benefitDetail.viewExclusionProvisions.modal as vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          inpatientSettings: vm.basics,
        },
      });
    }
  }
})();
